<template>
  <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
  ></v-progress-circular>
  <div v-else class="mt-3">
    <div class="row">
      <div class="d-flex align-items-center justify-content-start col">
        <span style="margin-right: 1rem">Show</span>
        <b-form-select
            class="form-control"
            style="width: 20%"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
        ></b-form-select>
        <span style="margin-left: 1rem">entries</span>
      </div>
      <div class="d-flex align-items-center justify-content-end col">
        <label for="searchText" class="mx-3">Search: </label>
        <input
          id="searchText"
          type="text"
          v-model="searchText"
          class="form-control w-50"
          @change="getListBrands"
        />
      </div>
    </div>
    <b-table
        class="table table-bordered"
        hover
        :fields="fields"
        :items="listBrands"
        :per-page="perPage"
        @sort-changed="sortCompare"
        responsive
    >
      <template #cell(action)="data">
        <div class="d-flex justify-content-evenly">
          <router-link
              :to="{ name: 'DetailBrand', query: { brandCode: data.item.code } }"
              class="btn btn-outline-primary"
          >Detail</router-link
          >
        </div>
      </template>
    </b-table>
    <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
    ></b-pagination>
  </div>
</template>

<script>
import BrandService from "@/services/api/brand.service";
export default {
  data() {
    return {
      currentPage: 1,
      totalItems: null,
      searchText: null,
      isBusy: false,
      perPage: 10,
      pageOptions: [
        5,
        10,
        20,
        50,
        {
          value: null,
          text: "show all",
        },
      ],
      isLoading: false,
      sort: {
        key: null,
        type: false,
      },
      listBrands: [],
      fields: [
        {
          key: "code",
          label: "Brand Code",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "name",
          label: "Brand Name",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          thClass: "text-start",
          tdClass: "text-start",
          class: "table-width",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
        },
      ],
    };
  },
  mounted() {
    this.isLoading = true;
    this.getListBrands(this.sort);
  },
  methods: {
    async getListBrands(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage || this.totalItems,
          sortColumn: sort.key || "id",
          sortType: sort.type || "desc",
          key: this.searchText
        };
        await BrandService.getListBrands(param)
            .then((res) => {
              const data = res.data;
              this.totalItems = data.totalItems;
              this.listBrands = data.brand;
              this.isLoading = false;
            })
            .catch((err) => {
              console.log("Error: ", err);
              this.isLoading = false;
            });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    sortCompare(e) {
      let sortBy = e.sortBy
      if (sortBy === 'code') {
        sortBy = 'brandCode'
      } else if(sortBy === 'name') {
        sortBy = 'brandName'
      }
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getListBrands(this.sort);
    },
    changePage() {
      this.getListBrands(this.sort);
    },
    onChangeEntries() {
      this.getListBrands(this.sort);
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}

::v-deep .table-width {
  max-width: 5rem;
}
</style>
